import { gsap } from "../global/gsap";

const initScrollBtns = (scrollBtns) => { 
    scrollBtns.forEach((btn) => { 
        btn.addEventListener("click", (e) => {  console.log(btn);
            e.preventDefault();

            const target = btn.getAttribute("href");

            gsap.to(window, {
                duration: 0.8,
                scrollTo: {
                    y: target,
                    autoKill: true,
                },
                ease: "power2.inOut",
            });
        });
    });
};

export { initScrollBtns as default };
